<mat-dialog-content>
    <div class="flex column gap-16">
      <h4>{{ 'general.form' | translateWithKeys }}</h4>
      <hr class="separator">
  
      <div class="mb-2 mt-1r">
        <p>{{ 'general.form_link' | translateWithKeys }}</p>
        <mat-form-field appearance="outline" class="w-100">
        <span class="pl-16" matPrefix>https://</span>
          <input matInput [formControl]="formLinkControl" placeholder="Enter form link" />
          <mat-error *ngIf="formLinkControl.invalid && formLinkControl.touched">
            {{ 'general.invalid_link_format' | translateWithKeys }}
          </mat-error>
        </mat-form-field>
      </div>
      @if (formLinkControl.valid && formLinkControl.value?.trim()) {
        <div class="mb-2">
          <mat-checkbox [(ngModel)]="assignedCategory.requireFormFirst" [ngModelOptions]="{standalone: true}">
            <p class="no-margin">{{ 'general.required_first' | translateWithKeys }}</p>
          </mat-checkbox>
        </div>
      }
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions>
    <div class="flex row end w-100">
      <button mat-stroked-button class="button" (click)="close()">
        {{ 'general.close' | translateWithKeys }}
      </button>
      <button
        mat-stroked-button
        class="button save-button"
        (click)="save()"
        [disabled]="formLinkControl.invalid"
      >
        {{ 'general.save' | translateWithKeys }}
      </button>
    </div>
  </mat-dialog-actions>
  